module.exports = __webpack_public_path__ + "static/img/hall03.128df6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/hall03.jpg
// module id = 0AYu
// module chunks = 1